import React, { Component, Fragment } from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import compose from "ramda/src/compose";
import {
  Form,
  Button,
  FloatLabelInput,
  FloatLabelTextArea,
} from "shared/components";
import Loader from "../../../../../../components/Loading";

import styles from "./styles.css";

import * as Validation from "../../../../../../services/utils/validation";
import * as Mask from "../../../../../../services/utils/mask";
import { createCommonIncident } from "../../../../../../services/state/actions";

class FormCheckListClearChannel extends Component {
  // TODO: Refatorar, métodos utilizados em formulários
  renderInputField(field, props) {
    const {
      meta: { touched, error, invalid },
    } = field;

    return (
      <FloatLabelInput
        {...field.input}
        {...props}
        id={field.id}
        label={field.label}
        maxLength={field.id === "contactPhone" ? "15" : ""}
        icon={field.icon}
        iconClick={field.iconClick}
        type={field.type}
        invalid={touched && invalid}
        error={error}
      />
    );
  }

  renderReasonInput = (field) => {
    const {
      meta: { touched, error, invalid },
    } = field;
    return (
      <FloatLabelTextArea
        id="description"
        name="description"
        label={field.label}
        preset="modalTextArea"
        onChange={field.input.onChange}
        value={field.input.value || ""}
        invalid={touched && invalid}
        error={error}
        noResize
      />
    );
  };

  onSubmit = (form) => {
    const { t, reason, createCommonIncident, onNextStep, onReset } = this.props;

    const checklist = {
      data: { ...form, reason },
      labels: {
        reason: t("MSG_0397"),
        description: t("MSG_0202"),
        calledInternal: t("MSG_0203"),
        openingTime: t("MSG_0204"),
        testingScheduler: t("MSG_0205"),
        contactPhone: t("MSG_0206"),
        failureDate: t("FAILURE_DATE"),
        failureTime: t("FAILURE_TIME"),
      },
    };

    return createCommonIncident(checklist, onNextStep, onReset);
  };

  render() {
    const {
      t,
      submitting,
      handleSubmit,
      onPreviousStep,
      failureDate,
    } = this.props;

    return (
      <Fragment>
        <Form onSubmit={handleSubmit(this.onSubmit)}>
          <fieldset className={styles.noPadding}>
            <Field
              id="description"
              name="description"
              label={t("MSG_0202")}
              component={this.renderReasonInput}
              validate={[Validation.isRequired]}
            />
            {failureDate && (
              <Fragment>
                <Field
                  id="failureDate"
                  label={t("FAILURE_DATE")}
                  name="failureDate"
                  component={this.renderInputField}
                  normalize={Mask.date}
                  format={Mask.date}
                  validate={[Validation.isRequired, Validation.isValidDate]}
                />

                <Field
                  id="failureTime"
                  label={t("FAILURE_TIME")}
                  name="failureTime"
                  component={this.renderInputField}
                  normalize={Mask.time}
                  format={Mask.time}
                  validate={[Validation.isRequired, Validation.isTime]}
                />
              </Fragment>
            )}

            <Field
              id="calledInternal"
              label={t("MSG_0203")}
              name="calledInternal"
              component={this.renderInputField}
              validate={[Validation.isRequired]}
            />

            <Field
              id="openingTime"
              label={t("MSG_0204")}
              name="openingTime"
              format={Mask.time}
              normalize={Mask.time}
              component={this.renderInputField}
              validate={[Validation.isRequired]}
            />

            <Field
              id="testingScheduler"
              label={t("MSG_0205")}
              name="testingScheduler"
              format={Mask.timeRange}
              normalize={Mask.timeRange}
              component={this.renderInputField}
              validate={[Validation.isRequired]}
            />

            <Field
              id="contactPhone"
              label={t("MSG_0206")}
              name="contactPhone"
              format={Mask.phone}
              normalize={Mask.algarPhone}
              component={this.renderInputField}
              validate={[Validation.isRequired, Validation.isPhone]}
            />

            <div className={styles.actions}>
              <Button relevance="low" onClick={onPreviousStep}>
                {t("MSG_0292")}
              </Button>

              <Button
                type="submit"
                relevance="normal"
                callToAction
                disabled={submitting}
              >
                {t("MSG_0007")}
              </Button>
            </div>
          </fieldset>
        </Form>

        <Loader isOpen={submitting} />
      </Fragment>
    );
  }
}

const reduxFormConfig = {
  form: "FormCheckListClearChannel",
};

const enhance = compose(
  translate(),
  connect(null, { createCommonIncident }),
  reduxForm(reduxFormConfig)
);

export default enhance(FormCheckListClearChannel);



// WEBPACK FOOTER //
// ./src/components/RepairWizard/components/ModalClearChannel/Unavailable/FormCheckListClearChannel/index.js